import { Button, Typography, Box, Paper } from "@mui/material";
import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";

const ErrorPage = ({ error, onHandleReset, handleRefresh }) => {
  const [toggleErrorView, setToggleErrorView] = useState(false);

  const handleErrorViewButton = () => {
    setToggleErrorView(!toggleErrorView);
  };
  return (
    <Box
      sx={{
        minHeight: "88vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #EEF6FF 0%, #C7E2F8 100%)",
        padding: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          maxWidth: 500,
          width: "100%",
          padding: 4,
          textAlign: "center",
          borderRadius: 3,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 600, marginBottom: 1 }}>
          Oops! Something went wrong
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: "text.secondary", marginBottom: 3 }}
        >
          Please try refreshing the page or return to the home page.
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <Button variant="contained" color="primary" onClick={handleRefresh}>
            Refresh
          </Button>

          <Button variant="outlined" color="primary" onClick={onHandleReset}>
            Home Page
          </Button>
          <Button variant="outlined" color="error" onClick={handleErrorViewButton}>
            <VisibilityIcon/>
          </Button>
        </Box>

        {process.env.REACT_APP_ENV !== "prod" &&
          error?.message &&
          toggleErrorView && (
            <Box
              sx={{
                marginTop: 3,
                padding: 2,
                backgroundColor: "#ffecec",
                color: "#d32f2f",
                borderRadius: 2,
                textAlign: "left",
                fontSize: "0.875rem",
                overflow: "hidden",
              }}
            >
              <strong>Error:</strong>
              <pre style={{ margin: 0 }}>
                {error.message}
              </pre>
            </Box>
          )}
      </Paper>
    </Box>
  );
};

export default ErrorPage;
